/**
 * フィールドを並べ替えます。カスタムフィールドは対応、ウィジェットは未対応。
 *
 * Updated: 2023/10/02
 *
 * @param {Object} options
 * @param {String} options.sort 上からの並び順通りに `basename` をカンマ区切りで並べます。
 * @param {String} options.insertID フィールドを包含する要素のid属性の値
 * @param {Boolean} options.otherFieldHide trueにすると並び順を指定したフィールド以外のフィールドを非表示する。
 * @param {Boolean} options.debug trueにすると並び順に指定したフィールドがない場合はコンソールに通知する。
 * @returns {void}
 */
export function fieldSort(options) {
    const op = {
        sort: 'title,text,tags,excerpt,keywords',
        insertID: 'sortable',
        otherFieldHide: false,
        debug: false,
        ...options
    };

    const fields = op.sort.split(',').reverse();
    if (!fields.length) {
        return;
    }

    const container = document.getElementById(op.insertID);
    if (!container) {
        return;
    }

    if (op.otherFieldHide) {
        const divFields = container.querySelectorAll('div.field');
        divFields.forEach((div) => div.classList.add('d-none'));

        const quickpost = document.getElementById('quickpost');
        if (quickpost) quickpost.classList.add('d-none');
    }

    fields.forEach((f) => {
        let id = f.trim().replace(/^c:/, 'customfield_') + '-field';
        if (id === 'category-field') {
            id = 'category-field-wrapper';
        }
        const elm = document.getElementById(id);
        if (elm) {
            container.insertBefore(elm, container.firstChild);
            elm.classList.remove('d-none');
            elm.style.display = 'block';

            if (id === 'category-field-wrapper') {
                elm.classList.add('mt-3');
                const otherCategoryList = document.getElementById('other-type-category-list');
                if (!otherCategoryList) {
                    const categoryField = document.getElementById('category-field');
                    if (categoryField) {
                        categoryField.classList.remove('d-none');
                        categoryField.style.display = 'block';
                    }
                }
            }
        } else if (op.debug && window.console) {
            console.warn('#' + id + ' が見つかりません');
        }
    });
}
